import { useEffect, useState } from "react";
import { DEFAULT_TAXONOMIES, loadTaxonomies, Taxonomies } from "../lib/taxonomies";

export function useTaxonomies() {
  const [taxonomies, setTaxonomies] = useState<Taxonomies>(DEFAULT_TAXONOMIES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    loadTaxonomies().then((t) => {
      if (!active) return;
      setTaxonomies(t);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  return { taxonomies, setTaxonomies, loading };
}
